// Live chat: the staff inbox of the chat on the website (#284 B3; only where the API has the chat).
export const livechatEn = {
  'livechat.subtitle': 'Chats from the chat bubble on your website. Each chat is deleted {days} days after its last message.',
  'livechat.siteOff': 'The chat is switched off on the website right now, so visitors cannot start a chat. Chats from the last {days} days still show here.',
  'livechat.tab.needs': 'Needs a person',
  'livechat.tab.open': 'Open',
  'livechat.tab.closed': 'Closed',
  'livechat.col.visitor': 'Last message',
  'livechat.col.page': 'Page',
  'livechat.col.started': 'Started',
  'livechat.col.last': 'Last message at',
  'livechat.col.email': 'Email left',
  'livechat.col.holder': 'Taken by',
  'livechat.col.actions': 'Actions',
  'livechat.open': 'Open',
  'livechat.yes': 'Yes',
  'livechat.no': 'No',
  'livechat.nobody': '—',
  'livechat.noText': '(no message yet)',
  'livechat.empty.needs': 'No chat is waiting for a person.',
  'livechat.empty.open': 'No open chats.',
  'livechat.empty.closed': 'No closed chats in the last {days} days.',
  'livechat.empty.title': 'Nothing here',
  'livechat.notAvailable': 'Live chat is not part of this CMS.',

  'livechat.back': '← All chats',
  'livechat.title': 'Chat from page {page}',
  'livechat.status.open': 'Open',
  'livechat.status.closed': 'Closed',
  'livechat.needsPerson': 'Needs a person',
  'livechat.lang': 'Language: {lang}',
  'livechat.started': 'Started {date}',
  'livechat.live': 'Live',
  'livechat.polling': 'Reconnecting… (updating every 3 s)',
  'livechat.gone': 'This chat no longer exists. Chats are deleted {days} days after the last message.',
  'livechat.typing': 'The visitor is typing…',

  'livechat.who.visitor': 'Visitor',
  'livechat.who.bot': 'DigiCS (prepared answer: {code})',
  'livechat.who.staff': 'Digimasi team · {name}',
  'livechat.internal': 'Internal: the visitor does not see this',
  'livechat.suggestion.title': 'DigiCS suggests the prepared answer "{code}"',
  'livechat.suggestion.send': 'Send this answer',
  'livechat.suggestion.sent': 'Sent to the visitor',
  'livechat.suggestion.sentToast': 'The answer was sent',
  'livechat.contact.title': 'Contact form',
  'livechat.contact.name': 'Name',
  'livechat.contact.email': 'Email',
  'livechat.contact.consent': 'Agreed to be contacted at this email',
  'livechat.note.by': 'Note by {name}',
  'livechat.action.take': '{name} took over the chat',
  'livechat.action.takeFrom': '{name} took the chat over from {from}',
  'livechat.action.release': '{name} gave the chat back to DigiCS',
  'livechat.action.handoff': '{name} handed the chat to {to}',
  'livechat.action.send_suggestion': '{name} sent the suggested answer "{code}"',
  'livechat.action.close': '{name} closed the chat',
  'livechat.notice.handover_fallback': 'The visitor was told the team will reply here',
  'livechat.notice.contact_thanks': 'The visitor was thanked for the contact',
  'livechat.notice.chat_closed': 'The visitor saw the closing line',
  'livechat.notice.contact_form': 'The visitor was shown the contact form',
  'livechat.notice.other': 'Notice: {text}',

  'livechat.holder.title': 'Who answers',
  'livechat.holder.free': 'Nobody has taken this chat. DigiCS works by its mode (suggest: you see its suggestion and decide).',
  'livechat.holder.mine': 'You have this chat. DigiCS stays silent until you give it back.',
  'livechat.holder.other': '{name} has this chat.',
  'livechat.take': 'Take over',
  'livechat.takeForce': 'Take over anyway',
  'livechat.release': 'Give back to DigiCS',
  'livechat.handoff': 'Hand to a colleague',
  'livechat.handoffTo': 'Colleague',
  'livechat.handoffNone': 'No colleague can answer chats yet.',
  'livechat.handoffSend': 'Hand over',
  'livechat.close': 'Close chat',
  'livechat.closeConfirm.title': 'Close this chat?',
  'livechat.closeConfirm.body': 'The visitor sees a short closing line and cannot write here any more. The chat stays readable until it is deleted.',
  'livechat.replyEmail': 'Reply by email',
  'livechat.replyEmailHint': 'Opens a new email in the Inbox with the address, a subject and their last message filled in. Their answer comes back to the Inbox.',
  'livechat.toast.taken': 'You have this chat now',
  'livechat.toast.released': 'DigiCS has the chat again',
  'livechat.toast.handed': '{name} has the chat now',
  'livechat.toast.closed': 'Chat closed',
  'livechat.toast.note': 'Note added',

  'livechat.compose.reply': 'Reply',
  'livechat.compose.note': 'Internal note',
  'livechat.reply.label': 'Reply to the visitor',
  'livechat.reply.placeholder': 'Write a reply…',
  'livechat.reply.send': 'Send',
  'livechat.reply.hint': 'Plain text, up to {max} characters. The visitor sees it from "Tim Digimasi", not your name.',
  'livechat.reply.needTake': 'Take over the chat to reply.',
  'livechat.reply.closed': 'This chat is closed.',
  'livechat.note.label': 'Internal note',
  'livechat.note.placeholder': 'Write a note for the team…',
  'livechat.note.add': 'Add note',
  'livechat.note.hint': 'Only your team sees notes, never the visitor.',
  'livechat.count': '{n}/{max}',
} as const

export const livechatId: Record<keyof typeof livechatEn, string> = {
  'livechat.subtitle': 'Chat dari tombol chat di website Anda. Tiap chat dihapus {days} hari setelah pesan terakhirnya.',
  'livechat.siteOff': 'Chat di website sedang dimatikan, jadi pengunjung belum bisa mulai chat. Chat {days} hari terakhir tetap tampil di sini.',
  'livechat.tab.needs': 'Perlu dibalas orang',
  'livechat.tab.open': 'Terbuka',
  'livechat.tab.closed': 'Ditutup',
  'livechat.col.visitor': 'Pesan terakhir',
  'livechat.col.page': 'Halaman',
  'livechat.col.started': 'Mulai',
  'livechat.col.last': 'Pesan terakhir pada',
  'livechat.col.email': 'Ada email',
  'livechat.col.holder': 'Dipegang',
  'livechat.col.actions': 'Aksi',
  'livechat.open': 'Buka',
  'livechat.yes': 'Ya',
  'livechat.no': 'Tidak',
  'livechat.nobody': '—',
  'livechat.noText': '(belum ada pesan)',
  'livechat.empty.needs': 'Tidak ada chat yang menunggu dibalas orang.',
  'livechat.empty.open': 'Tidak ada chat terbuka.',
  'livechat.empty.closed': 'Tidak ada chat yang ditutup dalam {days} hari terakhir.',
  'livechat.empty.title': 'Belum ada apa-apa',
  'livechat.notAvailable': 'Live chat tidak termasuk di CMS ini.',

  'livechat.back': '← Semua chat',
  'livechat.title': 'Chat dari halaman {page}',
  'livechat.status.open': 'Terbuka',
  'livechat.status.closed': 'Ditutup',
  'livechat.needsPerson': 'Perlu dibalas orang',
  'livechat.lang': 'Bahasa: {lang}',
  'livechat.started': 'Mulai {date}',
  'livechat.live': 'Langsung',
  'livechat.polling': 'Menyambung ulang… (diperbarui tiap 3 detik)',
  'livechat.gone': 'Chat ini sudah tidak ada. Chat dihapus {days} hari setelah pesan terakhir.',
  'livechat.typing': 'Pengunjung lagi mengetik…',

  'livechat.who.visitor': 'Pengunjung',
  'livechat.who.bot': 'DigiCS (jawaban siap: {code})',
  'livechat.who.staff': 'Tim Digimasi · {name}',
  'livechat.internal': 'Internal: pengunjung tidak melihat ini',
  'livechat.suggestion.title': 'DigiCS menyarankan jawaban siap "{code}"',
  'livechat.suggestion.send': 'Kirim jawaban ini',
  'livechat.suggestion.sent': 'Sudah dikirim ke pengunjung',
  'livechat.suggestion.sentToast': 'Jawaban terkirim',
  'livechat.contact.title': 'Form kontak',
  'livechat.contact.name': 'Nama',
  'livechat.contact.email': 'Email',
  'livechat.contact.consent': 'Setuju dihubungi lewat email ini',
  'livechat.note.by': 'Catatan dari {name}',
  'livechat.action.take': '{name} mengambil alih chat',
  'livechat.action.takeFrom': '{name} mengambil alih chat dari {from}',
  'livechat.action.release': '{name} mengembalikan chat ke DigiCS',
  'livechat.action.handoff': '{name} menyerahkan chat ke {to}',
  'livechat.action.send_suggestion': '{name} mengirim jawaban saran "{code}"',
  'livechat.action.close': '{name} menutup chat',
  'livechat.notice.handover_fallback': 'Pengunjung diberi tahu tim akan membalas di sini',
  'livechat.notice.contact_thanks': 'Pengunjung diberi ucapan terima kasih untuk kontaknya',
  'livechat.notice.chat_closed': 'Pengunjung melihat kalimat penutup',
  'livechat.notice.contact_form': 'Pengunjung diberi form kontak',
  'livechat.notice.other': 'Pemberitahuan: {text}',

  'livechat.holder.title': 'Siapa yang membalas',
  'livechat.holder.free': 'Belum ada yang mengambil chat ini. DigiCS bekerja sesuai mode-nya (saran: Anda lihat sarannya lalu memutuskan).',
  'livechat.holder.mine': 'Chat ini Anda pegang. DigiCS diam sampai Anda kembalikan.',
  'livechat.holder.other': 'Chat ini dipegang {name}.',
  'livechat.take': 'Ambil alih',
  'livechat.takeForce': 'Tetap ambil alih',
  'livechat.release': 'Kembalikan ke DigiCS',
  'livechat.handoff': 'Serahkan ke rekan',
  'livechat.handoffTo': 'Rekan',
  'livechat.handoffNone': 'Belum ada rekan yang bisa membalas chat.',
  'livechat.handoffSend': 'Serahkan',
  'livechat.close': 'Tutup chat',
  'livechat.closeConfirm.title': 'Tutup chat ini?',
  'livechat.closeConfirm.body': 'Pengunjung melihat kalimat penutup singkat dan tidak bisa menulis lagi di sini. Chat tetap bisa dibaca sampai dihapus.',
  'livechat.replyEmail': 'Balas lewat email',
  'livechat.replyEmailHint': 'Membuka email baru di Kotak Masuk dengan alamat, subjek, dan pesan terakhirnya sudah terisi. Balasannya masuk ke Kotak Masuk.',
  'livechat.toast.taken': 'Chat ini sekarang Anda pegang',
  'livechat.toast.released': 'Chat kembali ke DigiCS',
  'livechat.toast.handed': 'Chat sekarang dipegang {name}',
  'livechat.toast.closed': 'Chat ditutup',
  'livechat.toast.note': 'Catatan ditambahkan',

  'livechat.compose.reply': 'Balas',
  'livechat.compose.note': 'Catatan internal',
  'livechat.reply.label': 'Balas pengunjung',
  'livechat.reply.placeholder': 'Tulis balasan…',
  'livechat.reply.send': 'Kirim',
  'livechat.reply.hint': 'Teks biasa, maksimal {max} karakter. Pengunjung melihatnya dari "Tim Digimasi", bukan nama Anda.',
  'livechat.reply.needTake': 'Ambil alih chat dulu untuk membalas.',
  'livechat.reply.closed': 'Chat ini sudah ditutup.',
  'livechat.note.label': 'Catatan internal',
  'livechat.note.placeholder': 'Tulis catatan untuk tim…',
  'livechat.note.add': 'Tambah catatan',
  'livechat.note.hint': 'Catatan hanya dilihat tim Anda, tidak pernah oleh pengunjung.',
  'livechat.count': '{n}/{max}',
}
